import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
/* eslint-disable max-len */
import React from 'react';
import { observer } from 'mobx-react-lite';
import { Box, FormControlLabel, Checkbox, } from '@mui/material';
import { clone } from 'lodash-es';
import { CancelOutlined, CheckCircle } from '@mui/icons-material';
import Explanation from './Explanation';
const MultipleChoiceAnswer = ({ answers, correctAnswer, setAnswer, isSubmit, userAnswers, }) => {
    // console.log(answers, correctAnswer, setAnswer);
    const setAnswerFn = (ev, answer) => {
        const newUserAnswers = clone(userAnswers);
        if (ev.target.checked) {
            newUserAnswers.push(answer.id);
        }
        else {
            const index = newUserAnswers.indexOf(answer.id);
            if (index > -1) {
                newUserAnswers.splice(index, 1);
            }
        }
        setAnswer(newUserAnswers);
    };
    return (_jsx(Box, { sx: { ml: '5%' }, children: answers.map((answer) => (_jsxs(React.Fragment, { children: [_jsx(FormControlLabel, { id: answer.id, sx: {
                        width: '80%',
                        border: isSubmit && userAnswers.includes(answer.id)
                            ? correctAnswer.includes(answer.id)
                                ? '2px solid green'
                                : '2px solid red'
                            : '',
                        my: 1,
                    }, name: answer.id, label: answer.answerText, labelPlacement: "end", "aria-labelledby": `label-${answer.id}`, control: (_jsxs(_Fragment, { children: [isSubmit && !correctAnswer.includes(answer.id)
                                && _jsx(CancelOutlined, { sx: { color: 'red', m: 1 } }), isSubmit && correctAnswer.includes(answer.id)
                                && _jsx(CheckCircle, { sx: { color: 'green', m: 1 } }), !isSubmit && (_jsx(Checkbox, { sx: {
                                    color: 'contract.main',
                                    '&$checked': {
                                        color: '#007bad',
                                    },
                                    '&$disabled': {
                                        color: '#007bad',
                                    },
                                }, checked: userAnswers.includes(answer.id), onChange: (ev) => setAnswerFn(ev, answer), value: answer.id, disabled: isSubmit }))] })) }), isSubmit && Boolean(answer.explanation) && (_jsx(Explanation, { explanation: answer.explanation }))] }, answer.id))) }));
};
export default observer(MultipleChoiceAnswer);
//# sourceMappingURL=MultipleChoiceAnswer.js.map